/* src/app/intro/buttons/buttons.component.scss */
ion-icon {
  font-size: 50px;
  color: #000;
  background-color: transparent;
}
.nextButton {
  background-color: transparent;
}
--ion-toolbar-background {
  background-color: transparent;
}
/*# sourceMappingURL=buttons.component.css.map */
